import { render, staticRenderFns } from "./insPeople.vue?vue&type=template&id=e661b0a2"
import script from "./insPeople.vue?vue&type=script&lang=js"
export * from "./insPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports